export const documents = [
  // 📂 Documents d’état civil
  { nom: "Acte de naissance du donateur", destinataire: "donateur" },
  { nom: "Acte de naissance du donataire", destinataire: "donataire" },
  { nom: "Livret de famille (si lien de parenté)", destinataire: "commun" },

  // 📂 Documents d’identité et de domicile
  { nom: "Justificatif d’identité du donateur", destinataire: "donateur" },
  { nom: "Justificatif d’identité du donataire", destinataire: "donataire" },
  { nom: "Justificatif de domicile du donateur (facture, attestation)", destinataire: "donateur" },
  { nom: "Justificatif de domicile du donataire (facture, attestation)", destinataire: "donataire" },

  // 📂 Documents financiers
  { nom: "Relevé d’identité bancaire (RIB) du donateur", destinataire: "donateur" },
  { nom: "Justificatif de l’origine des fonds donnés (relevés bancaires, épargne, vente de bien, etc.)", destinataire: "donateur" },

  // 📂 Donation de sommes d’argent
  { nom: "Formulaire de déclaration de don manuel (CERFA n°2735)", destinataire: "commun" },

  // 📂 Donation de biens immobiliers
  { nom: "Titre de propriété du bien donné", destinataire: "commun" },
  { nom: "Dernier avis de taxe foncière", destinataire: "commun" },
  { nom: "Plans cadastraux ou références cadastrales", destinataire: "commun" },
  { nom: "Diagnostics immobiliers (si requis)", destinataire: "commun" },
  { nom: "Évaluation ou estimation de la valeur du bien", destinataire: "commun" },

  // 📂 Donation de biens mobiliers (valeurs, œuvres, véhicules, etc.)
  { nom: "Justificatif de propriété des biens mobiliers donnés", destinataire: "donateur" },
  { nom: "Certificat d’expertise ou estimation des biens mobiliers", destinataire: "commun" },

  // 📂 Documents fiscaux
  { nom: "Dernier avis d’imposition du donateur", destinataire: "donateur" },
  { nom: "Justificatif de paiement des droits de donation (si applicables)", destinataire: "commun" },

  // 📂 Documents juridiques et complémentaires
  { nom: "Projet ou acte de donation notarié", destinataire: "commun" },
  { nom: "Acceptation de la donation par le donataire", destinataire: "donataire" },
  { nom: "Clauses spécifiques (usufruit, réserve d’usufruit, charge, conditions particulières)", destinataire: "commun" },

  // 📂 Cas particuliers
  { nom: "Contrat de mariage du donateur (si applicable)", destinataire: "commun" },
  { nom: "Acte de divorce ou jugement de séparation (si applicable)", destinataire: "commun" },
  { nom: "Autorisation du conjoint (si le bien appartient à la communauté)", destinataire: "commun" },

  // 📂 Documents pour bénéficiaires étrangers (si applicable)
  { nom: "Certificat de coutume", destinataire: "commun" },
  { nom: "Certificat de capacité juridique", destinataire: "commun" },
  { nom: "Traduction officielle des actes étrangers", destinataire: "commun" },
];